import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import CustomInput from "../../../components/CustomeInput";
import { useDispatch, useSelector } from "react-redux";
import {
  addCoodBookOptions,
  getAllCodeBookOptions,
  updateCoodBookOptions,
} from "../../../Api/services/code-BookService";
import { useLocation, useParams } from "react-router-dom";
import { handleKeyDown } from "../../../utils/common/inputValidation";
import Loader from "../../../components/Loader";
import { withNamespaces } from "react-i18next";

function EditCodeBookOptions({ onClose, isEditMode, codeBookOption, t }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const schema = yup.object().shape({
    option: yup.string().required(t("code_books.forms.title_required")),
  });
  const { loading } = useSelector((state) => state?.codebook);
  const { id } = useParams();
  // check if the codebook is leave type
  const searchParams = new URLSearchParams(location.search);
  const title = searchParams.get("title");
  const isCodeBookLeaveType = title?.toLowerCase() === "leave type";

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (isEditMode) {
      setValue("option", codeBookOption.option);
      setValue("off_site", codeBookOption.off_site);
      setValue("annual_leave", codeBookOption.annual_leave);
    }
  }, [isEditMode, codeBookOption, setValue]);

  //submit event
  const onSubmit = async (data) => {
    console.log(data, "data");
    if (isEditMode) {
      // Update logic here
      const result = await dispatch(
        updateCoodBookOptions({ id: codeBookOption.id, data: data })
      );
      if (result?.payload && result.payload.success === true) {
        onClose();
        const data = {
          page_size: 5,
          order_by: "created_at",
          order_type: "asc",
          page: 1,
          search_text: "",
        };
        dispatch(getAllCodeBookOptions({ id: id, data: data }));
      }
    } else {
      // Add logic here
      const newdata = {
        ...data,
        codebook_id: id,
      };
      const result = await dispatch(addCoodBookOptions(newdata));
      if (result?.payload && result.payload.success === true) {
        onClose();
        const data = {
          page_size: 5,
          order_by: "created_at",
          order_type: "asc",
          page: 1,
          search_text: "",
        };
        dispatch(getAllCodeBookOptions({ id: id, data: data }));
      }
    }
    //
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="mt-4 mb-6">
        <CustomInput
          type="text"
          name="title"
          label={t("code_books.tables.Title")}
          id="title"
          onKeyDown={handleKeyDown}
          autoComplete="off"
          placeholder={t("code_books.tables.Title")}
          register={{ ...register("option") }}
          error={errors?.option}
        />
        {isCodeBookLeaveType && (
          <div className="flex flex-row gap-4 mt-4">
            <div className="items-center flex gap-2 text-base cursor-pointer">
              <input type="checkbox" {...register("annual_leave")} />
              <label
                htmlFor="checkbox"
                className="text-gray_900 text-base font-thin"
              >
                {t("code_books.tables.annual_leave")}
              </label>
            </div>
            <div className="items-center flex gap-2 text-base cursor-pointer">
              <input type="checkbox" {...register("off_site")} />
              <label
                htmlFor="checkbox"
                className="text-gray_900 text-base font-thin"
              >
                {t("code_books.tables.off_site")}
              </label>
            </div>
          </div>
        )}
      </div>
      <div className="flex justify-end bg-gray_50 rounded-[14px] py-5 px-[10px]">
        <button
          onClick={onClose}
          type="button"
          className="mr-1 border border-primary_orange text-sm font-semibold font-pop text-primary_orange py-2 px-[26px] rounded-[14px] transition-all ease-in-out duration-300 hover:bg-primary_orange hover:text-white bg-transparent"
        >
          {t("code_books.forms.cancel")}
        </button>
        <button
          disabled={loading}
          type="submit"
          className="mr-4 text-sm font-semibold font-pop text-white border border-transparent hover:border-primary_orange hover:text-primary_orange hover:bg-transparent py-2 px-[26px] rounded-[14px] transition-all ease-in-out duration-300 bg-primary_orange"
        >
          {loading ? <Loader /> : t("code_books.forms.save")}
        </button>
      </div>
    </form>
  );
}

export default withNamespaces()(EditCodeBookOptions);
